// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/distinte?societaId&tipo&stato&commessaId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","commessaId":"number","ordineId":"number","numero":"number","tipo":"MERCE|LAVORAZIONI","addebito":"NOSTRO|CLIENTE","descrizione":"string","stato":"BOZZA|CONFERMATA","confermataAt":"string","createdAt":"string","ordine":{"id":"number","numero":"string","stato":"string","flussoCommerciale":"string","societaId":"number"},"commessa":{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"},"confermataDa":{"id":"number","nome":"string","cognome":"string"},"_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
